var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwlBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 277,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 279,
    height: 276
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m154.7 11.51.898.51.995-.272 16.886-4.61 12.557 12.114.745.718 1.034-.018 17.507-.297 9.125 14.83.544.883 1.009.239 17.027 4.034 5.121 16.61.307.994.922.483 15.476 8.108.8 17.347.048 1.043.776.7 12.953 11.67-3.569 16.995-.215 1.024.578.872 9.621 14.498-7.714 15.58-.465.939.343.989 5.686 16.417-11.376 13.188-.683.792.084 1.042 1.396 17.307-14.327 9.968-.856.596-.179 1.027-2.984 17.113-16.38 6.12-.974.363-.428.947-7.18 15.844-17.405 1.884-1.029.111-.649.807-10.927 13.579-17.334-2.473-1.023-.146-.827.619-13.989 10.457-16.171-6.676-.954-.394-.954.394-16.171 6.676-13.989-10.457-.827-.619-1.023.146-17.334 2.473-10.927-13.579-.649-.807-1.03-.111-17.404-1.884-7.18-15.844-.428-.947-.974-.363-16.38-6.12-2.984-17.113-.179-1.027-.856-.596-14.327-9.968 1.396-17.307.084-1.042-.683-.792L5.305 163.91l5.686-16.417.343-.989-.465-.939-7.714-15.58 9.62-14.498.58-.872-.216-1.024L9.57 96.595l12.953-11.67.776-.699.048-1.043.8-17.347 15.476-8.108.922-.483.307-.995 5.121-16.61L63 35.608l1.01-.24.543-.883 9.125-14.829 17.508.297 1.033.018.745-.718L105.52 7.137l16.886 4.611.995.272.898-.51 15.2-8.635 15.2 8.635Z",
    fill: "#D9D9D9",
    stroke: "#70C1BB",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.7 11.51.898.51.995-.272 16.886-4.61 12.557 12.114.745.718 1.034-.018 17.507-.297 9.125 14.83.544.883 1.009.239 17.027 4.034 5.121 16.61.307.994.922.483 15.476 8.108.8 17.347.048 1.043.776.7 12.953 11.67-3.569 16.995-.215 1.024.578.872 9.621 14.498-7.714 15.58-.465.939.343.989 5.686 16.417-11.376 13.188-.683.792.084 1.042 1.396 17.307-14.327 9.968-.856.596-.179 1.027-2.984 17.113-16.38 6.12-.974.363-.428.947-7.18 15.844-17.405 1.884-1.029.111-.649.807-10.927 13.579-17.334-2.473-1.023-.146-.827.619-13.989 10.457-16.171-6.676-.954-.394-.954.394-16.171 6.676-13.989-10.457-.827-.619-1.023.146-17.334 2.473-10.927-13.579-.649-.807-1.03-.111-17.404-1.884-7.18-15.844-.428-.947-.974-.363-16.38-6.12-2.984-17.113-.179-1.027-.856-.596-14.327-9.968 1.396-17.307.084-1.042-.683-.792L5.305 163.91l5.686-16.417.343-.989-.465-.939-7.714-15.58 9.62-14.498.58-.872-.216-1.024L9.57 96.595l12.953-11.67.776-.699.048-1.043.8-17.347 15.476-8.108.922-.483.307-.995 5.121-16.61L63 35.608l1.01-.24.543-.883 9.125-14.829 17.508.297 1.033.018.745-.718L105.52 7.137l16.886 4.611.995.272.898-.51 15.2-8.635 15.2 8.635Z",
    stroke: "#70C1BB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.492 203.644c1.096 6.28-1.237 26.362-13.333 35.8-12.104 9.445-8.234 18.468-11.062 18.494-2.827.027-21.152-9.604-22.257-26.794-1.546-23.928 21.418-48.473 28.849-52.424",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.492 203.644c1.096 6.28-1.237 26.362-13.333 35.8-12.104 9.445-8.234 18.468-11.062 18.494-2.827.027-21.152-9.604-22.257-26.794-1.546-23.928 21.418-48.473 28.849-52.424",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.388 233.066c-2.942 3.978-10.276 12.436-9.825 23.311M102.071 231.47c-2.942 3.977-5.973 11.518-6.67 22.084M96.32 229.301c-2.377 3.536-5.425 14.658-5 21.141M91.54 226.805c-2.527 4.092-4.108 12.427-4.33 19.333M86.531 223.241c-2.942 3.978-3.34 12.833-2.951 17.525",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.495 264.518h-15.507v18.847h15.507v-18.847Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.495 264.518h-15.507v18.847h15.507v-18.847ZM208.165 264.518h-15.507v18.847h15.507v-18.847Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.551 162.984c-12.317-11.836-49.241-2.566-49.241-2.566-.027-1.5-.044-2.346-.044-2.346l-9.198 1.173-9.198-1.173s-.018.846-.045 2.346l-57.608 7.338s-10.01 103.023 37.163 107.177c13.766 1.208 20.887-1.737 26.789-5.406a5.53 5.53 0 0 1 5.797 0c5.902 3.677 14.437 5.644 26.789 5.406 46.953-.908 41.113-100.121 28.796-111.949Z",
    fill: "#B2B6B9",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.187 167.404c-.441-2.328-1.272-4.515-2.783-6.191-5.222-5.786-19.624-2.276-26.295-1.164a10.224 10.224 0 0 1-.053-1.941c-2.721.327-5.584.732-8.358 1.12l-8.359-1.173s-.018.847-.035 2.346c-.053 3.431-31.146-1.164-33.081 9.561-.619 3.431.23 6.959 1.149 10.31 3.498 12.692 8.367 25.366 16.964 34.688 8.597 9.323 21.586 14.676 33.081 10.584 7.351-2.62 13.315-8.732 17.751-15.673 6.883-10.777 10.602-23.963 10.479-37.122-.018-1.764-.124-3.598-.46-5.345Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.566 188.784c-.379 6.359 4.224 26.044 17.327 34.061 13.104 8.009 10.285 17.419 13.095 17.119 2.809-.299 19.915-11.941 19.067-29.149-1.184-23.954-28.274-48.632-40.582-51.921",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.566 188.784c-.379 6.359 4.224 26.044 17.327 34.061 13.104 8.009 10.285 17.419 13.095 17.119 2.809-.299 19.915-11.941 19.067-29.149-1.184-23.954-28.274-48.632-40.582-51.921",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.904 215.966c3.376 3.616 11.628 11.183 12.414 22.049M243.99 213.55c3.375 3.616 7.245 10.76 9.136 21.185M249.459 210.744c2.766 3.246 7.06 13.944 7.378 20.444M253.922 207.72c2.977 3.775 5.496 11.88 6.503 18.724M258.498 203.609c3.375 3.616 4.78 12.374 4.93 17.075",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.537 218.32s20.225-3.475 52.652-27.517c32.427-24.043 39.001-43.658 39.001-43.658s-36.28-2.152-37.278-1.12c-.999 1.032-32.772 24.298-32.772 24.298l-8.243 37.511-13.36 10.486Z",
    fill: "#fff",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.797 60.147c-27.01-15.77-69.015 3.634-86.439 16.555-17.424 12.92-48.172 47.45-40.856 77.816 7.316 30.375 26.233 66.801 44.302 72.19 29.078 8.661 61.275-14.712 58.589-57.029 40.609 15.073 81.12-18.68 80.829-46.339-.194-18.812-29.405-47.423-56.425-63.193Z",
    fill: "#B2B6B9",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.99 140.689c-6.52 2.417-20.119 4.287-28.99.935 0 0 10.691 26.186 28.592 25.119",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.99 140.689c-6.52 2.417-20.119 4.287-28.99.935 0 0 10.691 26.186 28.592 25.119",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.39 75.775c-15.224 11.29-21.453 34.979-21.656 45.484-.062 3.395-3.57 5.997-6.848 5.071-10.134-2.84-25.58-10.46-40.803.829-30.112 22.323 3.65 87.836 33.054 91.302 24.731 2.91 45.725-28.479 44.435-51.587 18.237 7.215 65.481-8.652 69.837-33.127 5.169-29.096-47.209-80.815-78.019-57.972Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.305 184.331c5.571-4.129 5.051-14.245-1.16-22.594-6.212-8.348-15.763-11.769-21.334-7.639-5.57 4.129-5.051 14.245 1.16 22.594 6.212 8.349 15.763 11.769 21.334 7.639ZM183.791 146.648c5.571-4.13 5.051-14.245-1.16-22.594-6.211-8.349-15.763-11.769-21.333-7.64-5.571 4.13-5.052 14.246 1.16 22.594 6.211 8.349 15.763 11.769 21.333 7.64Z",
    fill: "#3E3E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 141.623s8.367 15.32 24.501 12.894",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 141.623s10.585 21.45 26.71 19.033",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.244 60.438c4.206-5.53 9.923-17.983 9.278-27.438 0 0 22.027 17.78 15.824 34.582",
    fill: "#B2B6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.244 60.438c4.206-5.53 9.923-17.983 9.278-27.438 0 0 22.027 17.78 15.824 34.582",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.521 33s12.273 12.427 5.284 27.138",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.521 33s17.513 16.308 10.533 31.028",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.78 147.523c-15.392 11.413-18.608 33.127-7.175 48.491 11.433 15.364 33.187 18.575 48.579 7.162 15.391-11.413 18.608-33.127 7.174-48.491-11.424-15.364-33.178-18.574-48.578-7.162Zm38.117 51.225c-12.945 9.596-31.234 6.906-40.848-6.024-9.613-12.92-6.918-31.177 6.035-40.773 12.953-9.596 31.234-6.906 40.847 6.024 9.614 12.921 6.91 31.177-6.034 40.773Z",
    fill: "#31B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.194 203.863-12.202 1.949-7.299-9.808 5.39-11.095 14.11 18.954ZM152.267 145.126c11.433 15.363 33.187 18.574 48.579 7.161 15.391-11.413 18.608-33.127 7.174-48.491-11.433-15.364-33.187-18.574-48.578-7.161-15.392 11.412-18.617 33.118-7.175 48.491Zm4.427-3.29c-9.613-12.921-6.919-31.178 6.034-40.774 12.954-9.596 31.235-6.906 40.848 6.024 9.613 12.921 6.918 31.178-6.035 40.774-12.953 9.595-31.225 6.897-40.847-6.024Z",
    fill: "#31B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.065 114.256 17.167-19.826-7.298-9.808-23.971 10.68 14.102 18.954ZM147.725 133.288l-18.797 13.935 5.784 7.774 18.797-13.935-5.784-7.774Z",
    fill: "#31B1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.212 164.043s.053.115.15.3l-.185-.282c-1.988 1.155-1.184 8.114.91 10.399 2.085 2.284 3.499 6.588 4.718 6.658 1.219.071 4.709-8.819 2.28-12.982-1.573-2.673-5.876-5.248-7.873-4.093Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.57 161.724-.053.035c-2.854 1.658-5.019 9.058-3.137 13.08 1.573 3.36 13.987 11.069 13.996 11.069 1.458-1.076-6.777-11.783.344-17.922-1.369-4.233-8.296-7.911-11.15-6.262Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.981 192.937 4.091 5.979s-5.08 11.351-8.005 11.59c-2.924.238-12.096-14.562-10.885-16.264 1.219-1.702 14.799-1.305 14.799-1.305ZM181.162 190.088l4.091 5.98s12.441-.582 13.731-3.21c1.29-2.637-9.181-16.555-11.204-16.043-2.032.502-6.618 13.273-6.618 13.273Z",
    fill: "#31B1B6",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.204 190.055-4.54 3.092 4.089 5.982 4.54-3.093-4.089-5.981Z",
    fill: "#31B1B6",
    stroke: "#3E3E3C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlBad);
export default __webpack_public_path__ + "static/media/owl-bad.f3d12aed4364977cfd87087612ed5597.svg";
export { ForwardRef as ReactComponent };